import { call, select } from 'redux-saga/effects';
import { selectE2eeEnabled } from 'features/e2ee/e2eeSlice';
import { FeedId, MediaStreamInfo } from 'features/streaming/types';
import { UserId } from 'features/users/types';
import { RTCClient } from 'utils/webrtc';

export function* cleanupScreenshareStreamsSaga(params: {
  userId: UserId;
  feedId: FeedId;
  streams: MediaStreamInfo[];
}) {
  const { userId, feedId, streams } = params;

  const e2eeEnabled: boolean = yield select(selectE2eeEnabled);

  RTCClient.receivingFeed.subscribedScreenshares[feedId] = false;

  for (const stream of streams) {
    yield call(RTCClient.disableScreensharingMedia, userId, stream.type);
    yield call(RTCClient.receivingFeed.removeStreamTrack, feedId, stream.mid);

    if (e2eeEnabled) {
      yield call(RTCClient.receivingFeed.removeE2eePendingSubscription, {
        userId,
        feedId,
        mid: stream.mid,
      });
    }
  }
}
